module.exports = __webpack_public_path__ + "img/frame_mobile.75190ac2.png";